var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_38502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5047 31.6922C20.7109 27.6797 28.0234 17.9547 28.0234 12.4922C28.0234 5.86719 22.6484 0.492188 16.0234 0.492188C9.39844 0.492188 4.02344 5.86719 4.02344 12.4922C4.02344 17.9547 11.3359 27.6797 14.5422 31.6922C15.3109 32.6484 16.7359 32.6484 17.5047 31.6922ZM16.0234 8.49219C17.0843 8.49219 18.1017 8.91361 18.8519 9.66376C19.602 10.4139 20.0234 11.4313 20.0234 12.4922C20.0234 13.5531 19.602 14.5705 18.8519 15.3206C18.1017 16.0708 17.0843 16.4922 16.0234 16.4922C14.9626 16.4922 13.9452 16.0708 13.195 15.3206C12.4449 14.5705 12.0234 13.5531 12.0234 12.4922C12.0234 11.4313 12.4449 10.4139 13.195 9.66376C13.9452 8.91361 14.9626 8.49219 16.0234 8.49219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_38502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0234375 0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDot);
export default __webpack_public_path__ + "static/media/location-dot.fd75d2c7bbefc735c6479ff21a390339.svg";
export { ForwardRef as ReactComponent };